import React from 'react';
import { inputClasses } from '../../utils/styles';
interface SuffixInputProps {
  id: string;
  value: string;
  onChange: (value: string) => void;
  suffix?: string;
  placeholder?: string;
  min?: number;
  max?: number;
  step?: number;
}
export function SuffixInput({
  id,
  value,
  onChange,
  suffix,
  placeholder,
  min,
  max,
  step
}: SuffixInputProps) {
  return <div className="relative" data-id="element-23" data-mp="26wibv0x6u7ed">
      <input id={id} type="number" inputMode="decimal" value={value} min={min} max={max} step={step} placeholder={placeholder} onChange={e => onChange(e.target.value)} className={`${inputClasses} tabular-nums ${suffix ? 'pr-10' : ''}`} data-id="element-24" data-mp="1j41tsqdgaff2" />
      {suffix && <span className="pointer-events-none absolute right-3.5 top-1/2 -translate-y-1/2 text-sm font-medium text-slate-400" data-id="element-25" data-mp="1n4u1hf6occ98">
          {suffix}
        </span>}
    </div>;
}